const http = {
    headers() {
        return {
            Accept: "application/json",
            "Content-Type": "application/json",
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content,
            'WEBSHOP-ID': document.head.querySelector('meta[name="webshop-id"]').content,
            'accept-Language': window.lan
        };
    },
    // The session expires after SESSION_LIFETIME of inactivity, but a page left open in a tab
    // (iOS Safari keeps them for weeks) still carries the old token -> 419 "CSRF token mismatch".
    // Loading the current page again starts a new session; take the token from it.
    refreshCsrf() {
        return fetch(window.location.href, {credentials: "same-origin", cache: "no-store"})
            .then((response) => response.text())
            .then((html) => {
                const match = html.match(/<meta[^>]+name="csrf-token"[^>]+content="([^"]+)"/);
                if (!match) {
                    return false;
                }
                document.head.querySelector('meta[name="csrf-token"]').content = match[1];
                return true;
            })
            .catch(() => false);
    },
    // POST JSON; on 419 refresh the token once and send it again.
    postJson(url, body) {
        const send = () => fetch(url, {
            method: "POST",
            headers: this.headers(),
            body: JSON.stringify(body),
        });
        return send().then((response) => {
            if (response.status !== 419) {
                return response;
            }
            return this.refreshCsrf().then((ok) => (ok ? send() : response));
        });
    }
};

window.http = http;
